import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { branch, compose, withHandlers, withProps } from 'recompose';


import omitProps from '../../../utils/omitProps';
import DropdownListInput from '../DropdownListInput';
import { querySelector } from '../../../utils';
import createOption from '../../../utils/dropdownListCreateOption';
import { fieldProps } from '../../../propTypes';


const propTypes = exact({
  operatorId: PropTypes.number,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  allowCreate: PropTypes.bool,

  createLease: PropTypes.func.isRequired,
  componentProps: PropTypes.object.isRequired,
  ...fieldProps,
});


const defaultProps = {
  operatorId: null,
  disabled: false,
  allowCreate: false,
};


const LeaseDropdownListInput = (props) => {
  const {
    input,
    meta,
    label,
    componentProps,
  } = props;

  return (
    <DropdownListInput
      input={input}
      meta={meta}
      label={label}
      messages={{ createOption }}
      componentProps={componentProps}
    />
  );
};


LeaseDropdownListInput.propTypes = propTypes;


LeaseDropdownListInput.defaultProps = defaultProps;


export const LeaseDropdownListInputFragment = gql`
  fragment LeaseDropdownListInput on Lease {
    id
    name
  }
`;


const GetAllLeasesQuery = gql`
  query GetAllLeases($operatorId: Int) {
    all_leases(operator_id: $operatorId) {
      edges {
        node {
          ...LeaseDropdownListInput
        }
      }
    }
  }
  ${LeaseDropdownListInputFragment}
`;


const CreateLeaseMutation = gql`
  mutation CreaterLease($input: LeaseCreateInput!) {
    lease_create(input: $input) {
      ...LeaseDropdownListInput 
    }
  }
  ${LeaseDropdownListInputFragment}
`;


const withData = graphql(GetAllLeasesQuery);


const mapDataToProps = branch(
  (props) => { return props.data.loading; },
  withProps((props) => {
    return {
      componentProps: {
        busy: true,
        data: [],
      },
    };
  }),
  withProps((props) => {
    const { data } = props;
    return {
      componentProps: {
        busy: false,
        data: querySelector(data, '$.all_leases.edges[*].node', []),
      },
    };
  }),
);


const withMutation = compose(
  graphql(CreateLeaseMutation),
  withHandlers({
    createLease: (props) => {
      const { mutate } = props;
      return (name) => {
        const variables = {
          name,
        };
        return mutate({ variables });
      };
    },
  }),
);


const withAdaptComponentProps = withProps((props) => {
  const { allowCreate, disabled, componentProps } = props;
  const mergedComponentProps = {
    ...componentProps,
    allowCreate,
    disabled,
    filter: 'contains',
    textField: 'name',
    valueField: 'id',
    onCreate: (value) => {},
  };
  return {
    componentProps: mergedComponentProps,
  };
});


const withDataConcerns = compose(
  withData,
  mapDataToProps,
);


const withConditionalSkip = branch(
  (props) => { return !props.disabled; },
  withDataConcerns,
);


const enhance = compose(
  withConditionalSkip,
  withMutation,
  withAdaptComponentProps,
  omitProps(['data', 'mutate']),
);


export default enhance(LeaseDropdownListInput);
